import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

// Password field with a persistent click-to-toggle visibility control.
// Default masked. One click reveals and it STAYS revealed (no auto-hide on blur,
// mouse release, focus change, or timeout). Click again to mask. Toggling never
// alters the entered value.
export const PasswordInput = React.forwardRef(function PasswordInput(
  { "data-testid": testid = "password-input", className = "", ...props },
  ref,
) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={visible ? "text" : "password"}
        data-testid={testid}
        className={`pr-10 ${className}`}
        {...props}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVisible((v) => !v)}
        data-testid={`${testid}-toggle`}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-slate-400 transition hover:text-slate-700"
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});
